export const GET_REQ_INFO = 'cargo-fetch-modal/GET_REQ_INFO';
export const getReqInfoAction = payload => ({
	type: GET_REQ_INFO,
	payload,
});

export const SET_REQ_INFO = 'cargo-fetch-modal/SET_REQ_INFO';
export const setReqInfoAction = payload => ({
	type: SET_REQ_INFO,
	payload,
});

export const SET_IS_REQ_INFO_LOADING = 'cargo-fetch-modal/SET_IS_REQ_INFO_LOADING';
export const setIsReqInfoLoadingAction = payload => ({
	type: SET_IS_REQ_INFO_LOADING,
	payload,
});

export const RESET_STATE = 'cargo-fetch-modal/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});

export const SET_IS_FORM_SENDING = 'cargo-fetch-modal/SET_IS_FORM_SENDING';
export const setIsFormSendingAction = payload => ({
	type: SET_IS_FORM_SENDING,
	payload,
});

export const SEND_FORM_ACTION = 'cargo-fetch-modal/SEND_FORM_ACTION';
export const sendFormAction = payload => ({
	type: SEND_FORM_ACTION,
	payload,
});
